import React, { Component } from 'react';

import Tooltip from './Tooltip';
import "../styles/charts.css";


class ChartTitle extends Component {
  constructor(props) {
    super(props);
    this.handleChart = this.handleChart.bind(this);
    this.handleMore = this.handleMore.bind(this);
  }

  render() {
    return (
        <div className="chartHeader">
          <div className="chartTitle">{this.props.title}
            &nbsp;
            <div className="chartTooltip"><Tooltip tip={this.props.tip} /></div>
          </div>
          {this.props.addDays && this.getDays()} 
          {this.props.addMoreLink && this.getMore()} 
        </div>
    );
  }

  getDays() {
    return (
      <div className="timeframePicker">
        {this.addDay()}
        {this.addWeek()}
        <button onClick={this.handleChart} value="M" className="animLink">M</button>
        <button onClick={this.handleChart} value="Y" className="animLink">Y</button>
        <button onClick={this.handleChart} value="All" className="animLink">All</button>
      </div>
    );
  }

  getMore() {
    // console.log(this.props.showMoreValue);
    return (
      <div className="timeframePicker">
        {this.props.showMoreValue === "false" && <button onClick={this.handleMore} value="true" className="animLink">Show More</button>}
        {this.props.showMoreValue === "true" && <button onClick={this.handleMore} value="false" className="animLink">Show Less</button>}
      </div>
    );
  }

  handleChart(e) {
    // alert(e.target.value);
    this.props.handleChart(e.target.value);
  }

  handleMore(e) {
    // alert(e.target.value);
    this.props.handleMore(e.target.value);
  }

}

export default ChartTitle;



// WEBPACK FOOTER //
// ./src/components/ChartTitle.js